import { render, staticRenderFns } from "./FacebookTopMentionGraph.vue?vue&type=template&id=6b366ec2&"
import script from "./FacebookTopMentionGraph.vue?vue&type=script&lang=js&"
export * from "./FacebookTopMentionGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports